<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-content" style="width: 1300px;margin: 40px auto;">
      <div class="m-content-opt"><span @click="toInfoBack" style="cursor:pointer;">电商快讯</span> > 快讯详情</div>
      <div class="m-zx-box">
        <div>
          <div class="m-zx-fx">
            <img src="../assets/img/lianjie.png" alt="">
          </div>
          <div class="m-zx-fx">
            <img src="../assets/img/weixin.png" alt="">
          </div>
        </div>
        <div class="m-zx-cont-box">
          <div class="m-zx-cont-c">
            <div class="m-zx-title">
              {{ dataList[listIndex].title }}
            </div>
            <div class="m-zx-len"></div>
            <div class="m-zx-cont">
              {{ dataList[listIndex].cont }}
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <div @click="openBuy" style="background-color: #9e0c0c;width: 140px;padding: 10px 0;text-align: center;color: white;border-radius: 5px;margin: 10px 0 0 0;cursor: pointer;">
                付费查看 ￥{{ dataList[listIndex].money }} 元
              </div>
            </div>
            <div class="m-zx-tips">
              更加详细情况，请关注本站最新动态。
            </div>
          </div>
        </div>
        <div class="m-zx-right">
          <div class="m-right-head">
            <div class="m-right-h-t">电商快讯</div>
            <div class="m-right-h-r" @click="toInfoBack">
              <img src="../assets/img/right.png" alt="">
            </div>
          </div>
          <div class="timeline2">
            <div v-for="item in dataList" :key="item.id" @click="toZiXun(item.id)" class="container2">
              <div class="content2">
                <h2>{{item.title}}</h2>
                <p>{{ item.cont }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m_bottom></m_bottom>
    <el-dialog title="请扫码支付" :visible.sync="openBuyState" @close='closeDialog' width="650px" center>
      <div class="m-open-container" style="margin-bottom: 40px;">
        <div style="text-align: center;">
          六十甲子订单 <span style="color: #9e0c0c; font-size: 16px; font-weight: bold;">支付金额 ￥5 元</span>
        </div>
        <div class="m-open-buy-opt">
          <div @click="selectBuyType(0)" class="m-open-buy-opt-item" :class="buyType === 0 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/zhifubao.gif" alt="">
            <div v-if="buyType === 0" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
          <div @click="selectBuyType(1)" class="m-open-buy-opt-item" :class="buyType === 1 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/weixin.gif" alt="">
            <div v-if="buyType === 1" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
        </div>
        <div class="m-open-buy-code">
          <img v-if="buyType === 0 && buyLoading === false" src="../assets/img/zfb.jpg" alt="">
          <img v-if="buyType === 1 && buyLoading === false" src="../assets/img/weixin.jpg" alt="">
          <div v-if="buyLoading" class="m-open-buy-code-load" v-loading="buyLoading"></div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <i class="el-icon-full-screen"></i>
          打开手机扫描二维码支付
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'subclassZiXun',
  data () {
    return {
      listIndex: 0,
      buyType: 0,
      openBuyState: false,
      buyLoading: false,
      dataList: [
        {id: '1', money: 5, title: '马家沟芹菜盒马村挂牌仪式举办', cont: '马家沟芹菜盒马村在青岛平度市马家沟芹菜产业示范园挂牌，打霜的芹菜刚刚结束采收季，于上周登陆盒马全国400多家门店。通过几年的合作，马家沟芹菜也从刚开始上架销售的几百份，到现在基地30%以上产量都供应给盒马。而上架盒马后，马家沟芹菜也打开了零售新渠道，到现在全国有超过20家连锁商超来马家沟“要货”，而马家沟芹菜产业园也从1200亩核心区，辐射到指导周边6万多亩，带动更多农户增收。'},
        {id: '2', money: 5, title: 'Tokopedia双11家居和电子产品交易额增长近9倍', cont: 'Tokopedia和Shop Tokopedia数据显示，家居和电子产品成为今年双11促销活动中最畅销的商品类别。Tokopedia及TikTok电商通讯主管Aditia Grasio Nelwan指出，今年双11交易额增长最高的类别为杂货、电子和家居用品，平均增幅接近9倍。'},
        {id: '3', money: 5, title: '派安盈橄榄枝计划新增平台Worten', cont: 'Payoneer派安盈橄榄枝计划新增平台Worten，据悉，Worten是葡萄牙最大的电商平台之一，拥有超过230万在线商品，年销售额超过14亿欧元。'},
        {id: '4', money: 5, title: '圆通出席第十七届中国-拉美企业家高峰会', cont: '第十七届中国-拉美企业家高峰会近日在尼加拉瓜首都马那瓜的奥洛夫·帕尔梅会议中心召开。圆通速递董事长喻渭蛟在参加2024年亚太经合组织(APEC)工商领导人峰会后，受邀出席本次高峰会并作主题发言。大会期间，圆通与尼加拉瓜交通和基础设施部（MTI）签订战略合作协议，助推尼加拉瓜提升运输及物流能力。'},
        {id: '5', money: 5, title: '银联国际：Lyf旗下超1.5万家商户支持银联二维码', cont: '银联国际今日宣布，与法国头部二维码收单机构Lyf合作了后者旗下超1.5万家商户支持银联二维码。即日起，云闪付APP和境内外银联标准钱包的用户都可在当地所有开通银联二维码服务的商户扫码支付。'},
        {id: '6', money: 5, title: '知乎创始人周源：AI搜索还在比较早期的阶段', cont: '2024世界互联网大会乌镇峰会期间。知乎创始人、董事长兼首席执行官周源谈及AI搜索带来的变化时表示：“我真的认为AI搜索整体来说还在一个比较早期的阶段，不管是国内还是全球范围内，所使用的人数频次和它所能够覆盖的场景，依然还在一个比较早期的阶段。甚至包括这个词，我也没有认为它完全清楚地去描绘了产品可以做的事情。”'},
        {id: '7', money: 5, title: 'Wayfair黑五网一大促正式开启', cont: 'Wayfair宣布，黑五网一大促今日正式开启。'},
        {id: '8', money: 5, title: '苏宁易采云与清风达成战略合作', cont: '苏宁易采云近日与金红叶纸业签署战略合作协议，双方将围绕金红叶旗下清风品牌的线上渠道建设、产品开发、联合营销、物流履约等方面，展开多维深度合作，探索绿色可持续的发展模式，共同推动商用纸品采购提质增效。'},
        {id: '9', money: 5, title: '东方嘉盛：何一鸣当选为公司第六届监事会之监事会主席', cont: '深圳市东方嘉盛供应链股份有限公司于2024年11月18日召开的第六届监事会第一次会议，审议通过了《关于选举公司监事会主席的议 案》。经选举，何一鸣当选为该公司第六届监事会之监事会主席，任期自监事会审议通过之日起至第六届监事会任期届满之日止。'},
        {id: '10', money: 5, title: '雷军：向实向善是AI服务社会进步的核心要义', cont: '小米集团创始人、董事长兼首席执行官雷军在2024年世界互联网大会乌镇峰会开幕式上表示，坚持智能向实、智能向善是人工智能科技服务社会进步的核心要义，满足人们对美好科技生活的向往是创新的重点。'},
        {id: '11', money: 5, title: '美团外卖投入10亿元助力餐饮商家创新', cont: '美团日前宣布投入10亿助力金，升级餐饮“繁盛计划”，为专注产品、探索创新的餐饮商家提供更多支持，共同推动行业健康发展。这笔助力金将用于助力优质中小商家提质增效、支持餐饮产品和模式创新、加速中华老字号数字化进程，所有现金支持将从今年12月31日起分批到账。'},
        {id: '12', money: 5, title: '小米授出4959.37万股奖励股份及合共5.1亿份小米香港购股权', cont: '小米集团公告，公司于2024年11月20日根据2023年股份计划奖励合共49,593,741股奖励股份予2,425名选定参与者，包括集团雇员及服务供应商。同日，小米香港根据2024年小米香港股份计划授出合共510,335,236份小米香港购股权予2,951名为小米香港集团雇员的小米香港选定参与者。'},
        {id: '13', money: 5, title: 'DP World成为SailGP全球智能物流合作伙伴', cont: 'DP World和SailGP宣布建立开创性的全球物流合作伙伴关系，DP World成为SailGP的全球智能物流合作伙伴。此次合作为期三个赛季，DP World将为横跨五大洲的SailGP赛事提供可持续、高效的运输解决方案。双方的合作将于2024年11月23-24日在P&O Marinas主办的阿联酋迪拜帆船大奖赛上首次亮相。'},
        {id: '14', money: 5, title: '双11顺丰同城全品类日均配送单量同比增长43%', cont: '2024“双十一”大促落下帷幕，全网销售总额达14418亿元，“双十一”当日快递量达7.01亿件，创历年新高。据顺丰同城数据，“双十一”期间其全品类日均配送单量同比增长43%，其中美妆、商超便利、饮品等单量均同比增超100%。此外，顺丰同城助阵传统快递网络提速的“最后一公里”业务单量同样达成新高，其中收件场景日均单量同比增长160%。即时物流成为各路玩家升级服务、拓宽销售渠道、留存消费者的关键支撑。'},
        {id: '15', money: 5, title: '周鸿祎评华为Mate 70：全球首个软硬芯云全自研完全体', cont: '360集团创始人周鸿祎发布视频表示，华为Mate 70从头到脚全部都是创新，包括核心芯片和软件操作系统的独立自主完全自研，甚至主要的零配件几乎都100%来自于自主可控的国内供应链。“再加上华为云是独立自主的云服务和华为自己的盘古大模型，Mate 70系列‘史上最强’真正内核是全球首个软硬芯云全自研完全体。”'},
        {id: '16', money: 5, title: '新氧公布三季度财报：总收入3.718亿元', cont: '新氧公布2024年第三季度未经审计财务业绩：总收入为人民币3.718亿元，而2023年同期为人民币3.853亿元，超过了预期的高位。归属于新氧国际的净利润为人民币2030万元，而2023年同期归属于新氧国际的净利润为人民币1830万元。非美国通用会计准则下归属于新氧国际的净利润为人民币2,220万元，而2023年同期非美国通用会计准则下归属于新氧国际的净利润为人民币950万元。'},
        {id: '17', money: 5, title: '互联网电商板块短线拉升 南极电商涨停', cont: '互联网电商板块短线拉升，南极电商涨停，凯淳股份涨超14%，星徽股份、国联股份、三态股份、华鼎股份等跟涨。'},
        {id: '18', money: 5, title: '逸仙电商Q3营收6.77亿元', cont: '逸仙电商发布2024年第三季度业绩报告：总净收入较去年同期的7.181亿元人民币下降5.7%至6.77亿元人民币；毛利率从去年同期的71.4%增至75.9%；毛利润较去年同期的5.128亿元人民币增长0.2%至5.138亿元人民币；净亏损为人民币1.211亿元，而去年同期为人民币1.979亿元；非公认会计准则净亏损为人民币7660万元，而去年同期为人民币1.302亿元。'},
        {id: '19', money: 5, title: 'PingPong加入Swift体系', cont: '全球支付平台PingPong正式宣布成为环球银行金融电信协会Swift的成员。加入Swift后，PingPong可直连Swift系统，并通过其安全网络实现在全球Swift成员间的快速通信，从而进一步优化PingPong的全球支付服务网络，为企业带来更高效、更安全的跨境支付体验。'},
        {id: '20', money: 5, title: '百胜中国11月19日斥资240万美元回购5.08万股', cont: '百胜中国发布公告，于2024年11月19日该公司斥资240万美元回购5.08万股，回购价格为每股46.84-47.52港元.'},
        {id: '21', money: 5, title: '叮当健康11月20日斥资22.52万港元回购38.7万股', cont: '叮当健康发布公告，于2024年11月20日该公司斥资22.52万港元回购38.7万股，回购价格为每股0.56-0.59港元。'},
        {id: '22', money: 5, title: '阿里巴巴11月19日斥资3999.22万美元回购366.64万股', cont: '阿里巴巴-W发布公告，于2024年11月19日该公司斥资3999.22万美元回购366.64万股，回购价格为每股10.85-10.99美元。'},
        {id: '23', money: 5, title: '良品铺子：股东达永有限减持公司股份达1.13%', cont: '良品铺子公告，公司收到股东达永有限的《减持实施情况告知函》，自11月1日至11月19日，达永有限通过大宗交易方式和集中竞价方式合计减持良品铺子股份452.45万股，超过公司总股本的1%。达永有限累计减持比例为1.13%，减持后仍为公司持股5%以上股东。'},
        {id: '24', money: 5, title: '吴泳铭：通义千问API调用价格一年下降97%', cont: '2024年世界互联网大会乌镇峰会开幕。阿里巴巴集团CEO吴泳铭透露，过去一年，阿里高强度投入AI基础设施建设，基于规模效应和技术进步，算力成本持续降低。“通义千问”API调用价格一年下降97%，百万token调用花费最低已经降到了5毛钱。他认为，“就像足够便宜的电力带来电气化时代的大爆发，足够便宜的算力终将把我们带进智能化时代”。'}
      ]
    }
  },
  created () {
    let id = this.$route.params.id
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id === id) {
        this.listIndex = i
      }
    }
  },
  methods: {
    toZiXun (id) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id === id) {
          this.listIndex = i
        }
      }
    },
    toInfoBack () {
      this.$router.back()
    },
    selectBuyType (type) {
      this.buyLoading = true
      this.buyType = type
      setTimeout(() => {
        this.buyLoading = false
      }, 1000)
    },
    closeDialog () {
    },
    openBuy () {
      this.openBuyState = true
    }
  },
  mounted () {
  }
}
</script>

<style>
.m-zx-box {
  display: flex;
  padding: 15px 0 0 0;
}
.m-zx-buy {
  width: 80px;
  margin: 20px 80px 0 0;
  border: 1px solid #ff4141;
  padding: 5px 10px;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-zx-buy:hover {
  background-color: #ff4141;
  color: white;
}
.m-zx-fx {
  width: 30px;
  height: 30px;
  border: 1px solid #555555;
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-zx-fx img {
  width: 100%;
}
.m-zx-fx:hover {
  background-color: #d4d4d4;
}
.m-zx-cont-box {
  flex: 1;
}
.m-zx-cont-c {
  margin: 0 0 0 20px;
  border: 1px solid #666666;
  padding: 20px;
  border-radius: 10px;
}
.m-zx-title {
  font-weight: bold;
  font-size: 26px;
}
.m-zx-cont {
  margin: 15px 0 0 0;
  font-size: 20px;
}
.m-zx-len {
  margin: 15px 0 0 0;
  border-top: 1px solid #666666;
}

.m-zx-tips {
  margin-top: 40px;
  background-color: #d4d4d4;
  color: #666666;
  padding: 10px 20px;
  border-radius: 5px;
}

.m-zx-right {
  width: 320px;
  margin: 0 0 0 30px;
  box-sizing: border-box;
}
.m-right-head {
  height: 40px;
  background-color: #36b9ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.m-right-h-t {
  color: white;
  padding-left: 20px;
  font-weight: bold;
}
.m-right-h-r {
  width: 26px;
  height: 26px;
  border-radius: 26px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border: 1px solid white;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-right-h-r img {
  width: 18px;
  height: 18px;
}
.m-right-h-r:hover {
  background-color: #3a8ee6;
}

.timeline2 {
  margin-top: 5px;
  overflow: auto; /* 设置为auto，内容超出时显示滚动条 */
  position: relative;
  width: 100%;
  height: 449px;
  -ms-overflow-style: none; /* Internet Explorer和Edge浏览器 */
}

.timeline2::-webkit-scrollbar {
  width: 0;
}

.container2::after {
  content: '';
  position: absolute;
  width: 2px;
  background-color: #b3b3b3;
  top: 0;
  bottom: 0;
  left: 8px;
}

.container2 {
  padding: 0 0 20px 20px;
  position: relative;
  background-color: inherit;
  width: 100%;
  box-sizing: border-box;
}

.container2::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  left: 4px;
  background-color: #b3b3b3;
  top: 50%;
  margin-top: -10px;
  border-radius: 50%;
  z-index: 1;
}

.content2 {
  width: 100%;
  height: 73px;
  text-align: left;
  padding: 10px 20px;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  box-sizing: border-box;
  cursor:pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}

.content2:hover {
  background-color: #cecece;
}

.content2 h2 {
  font-size: 14px;
  margin: 0;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.content2 p {
  font-size: 12px;
  margin: 3px 0 0 0;
  color: #6d6d6d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>



// WEBPACK FOOTER //
// src/components/SubclassZiXun.vue